<template>
    <div>
        <b-card no-body v-show="mostrarTabela">
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>APP Sebrae - Consultorias - Unidades Regionais</span>
                    <div class="float-right">
                        <span class="text-primary">
                            <i
                                class="fa fa-refresh fa-lg icon-button"
                                title="Atualizar"
                                @click.stop="obterUnidadesRegionais()"
                            ></i>
                        </span>
                    </div>
                </h4>
                <slot name="controles"></slot>
                <app-tabela
                    idTabela="tblUnidadesRegionais"
                    :itens="unidadesRegionais"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <btn-inserir-unidade-regional></btn-inserir-unidade-regional>
                        </b-button-group>
                        <slot name="botoes"></slot>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <slot name="acoes" v-bind="data"></slot>
                        <span
                            class="text-primary"
                            v-if="$temAcessoView('APPSE-CONS-UR-02')"
                        >
                            <i
                                class="fa fa-info-circle fa-lg icon-button"
                                title="Detalhar"
                                @click.stop="toDetalhar(data.unidadeRegionalId)"
                            ></i>
                        </span>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view></router-view>
    </div>
</template>

<script>
// import PagamentoInserir from './PagamentoInserir'
import UnidadesRegionaisServicos from './UnidadesRegionaisServicos'
import BtnInserirUnidadeRegional from './BtnInserirUnidadeRegional'

export default {
    props: {
        // titulo: {
        //     type: String,
        //     default: () => 'UNIDADES REGIONAIS'
        // }
        // pagamentos: {
        //     type: Array,
        //     default: () => []
        // },
        // pagamentosServicos: {
        //     type: Object,
        //     default: () => ({})
        // },
        // showFornecedor: {
        //     type: Boolean,
        //     default: true
        // }
    },

    data() {
        return {
            unidadesRegionais: [],
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'nome',
                    label: 'Unidade Regional',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'gestor',
                    label: 'Gestor',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime'
                }
            ],
            itensPorPagina: 5
        }
    },
    methods: {
        obterUnidadesRegionais() {
            this.$store.dispatch('addRequest')
            UnidadesRegionaisServicos.obterTodas().then((response) => {
                if (response) {
                    if (response.success) {
                        this.unidadesRegionais = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter unidades regionais',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        toDetalhar(unidadeRegionalId) {
            this.$router.push({
                name: 'AppSebrae_Consultorias_UnidadesRegionais_Detalhar',
                params: {
                    unidadeRegionalId: unidadeRegionalId
                }
            })
        }
    },

    created() {
        this.obterUnidadesRegionais()
    },

    computed: {
        mostrarTabela() {
            return (
                this.$route.name == 'AppSebrae_Consultorias_UnidadesRegionais'
            )
        }
    },

    watch: {
        $route(to) {
            if (to.name === 'AppSebrae_Consultorias_UnidadesRegionais') {
                if (this.$store.getters.recarregar) {
                    this.obterUnidadesRegionais()
                    this.$store.dispatch('setRecarregar', false)
                }
            }
        }
    },

    components: {
        BtnInserirUnidadeRegional
    }
}
</script>
